import { Island } from '../island.class';
import { IslandSkuAssetData } from '../data/island-sku-asset-data.class';

/**
 * Calculates island baseSize bsaed on island type. Base size represents the outside dimensions and do not include countertop overhangs
 * @param island Island to calculate the base size for
 * @param skuData [string, IslandAssetData]
 * @returns Size
 */
export const getBaseMsrpCfn = (island: Island, sku: string): number => {
	// console.log('getBaseMsrpCfn', sku);
	const { priceBook } = island.context;
	if (priceBook) return priceBook.findIslandSku(sku)?.msrp ?? 0;
	return IslandSkuAssetData?.findBySku(sku)?.msrp ?? 0;
};
